import {
	Button,
	Card,
	Pagination,
	Affix,
	List,
	Tabs,
	Steps,
	Radio,
	Drawer,
	Layout,
	Table,
	Tag,
	Dropdown,
	Modal,
	Form,
	Select,
	Switch,
	AutoComplete,
	Input,
	Upload,
	DatePicker,
} from 'antd';
import styled, { createGlobalStyle } from 'styled-components';
import Container from 'react-bootstrap/Container';
import { CardImg } from 'react-bootstrap';
const { Search } = Input;
const { Dragger } = Upload;
export const Theme = {
	colors: {
		white: '#FFFFFF',
		bodyBg: '#F4F6F9',

		themeColor1: '#212226',
		themeColor2: '#081D16',
		themeColor3: '#757575',
		themeColor4: '#7F8E89',
		themeColor5: '#11263C',

		themeColor7: '#0093AB',
		themeColor8: '#007299',
		themeColor9: '#48CF99',
		themeColor10: '#B3454B',
		themeColor11: '#6271B0',
		themeColor12: '#ED982A',
		themeColor13: '#00B2AA',

		themeColor14: '#D5001A',
		themeColor15: '#FF6A00',
		themeColor16: '#E5AA11',
		themeColor17: '#1F9254',

		themeColor18: '#B5BDEB',
		themeColor19: '#DCA5FC',
		themeColor20: '#E8EAF3',
		themeColor21: '#F0E5F6',

		themeColor22: '#ECECEC',
		themeColor23: '#D0E0DF',
		themeColor24: '#333333',
		themeColor25: '#7ee6e9',
		themeColor26: '#F7F9FD',
		themeColor27: '#F7F9FD',
		themeColor28: '#D8D8D7',
		themeColor29: '#e5f1f5',
		themeColor30: '#E57711',
		themeColor31: '#DB3A17',
		themeColor32: '#F7F8FA',

		themeTagColor1: '#fdf5ea',
		themeTagColor2: '#f7eced',

		fontPoppins: `'Poppins', sans-serif !important;`,
		//fontPoppins2: `'Poppins', sans-serif !important;`,
		fontDM: "'DM Sans', sans-serif !important ",
		fontInter: "'Inter', sans-serif !important ",

		/*Below is old color code*/
		menu1: '#a7a7a7',
		menu2: '#212226',
		color1: '#757575',
		color2: '#081D16',
		color3: '#d0e0df',
		color4: '#7f8e89',
		color5: '#f8f8f8',
		color6: '#dadee3',
		color7: '#11263c',
		color8: '#868FA0',
		color9: '#687182',
		color10: '#9B68BF',
		color12: '#57636F',
	},
	media: { mobile: '768px', tab: '998px' },
	CQColors: {
		white: '#FFFFFF',
		bodyBg: '#f9f9f9',
		primaryColor: '#202020', //Primary color
		secondaryColor: '#0E4C88', //Secondary color
		imgFilterColor:
			'brightness(0) saturate(100%) invert(20%) sepia(97%) saturate(1246%) hue-rotate(189deg) brightness(89%) contrast(93%);', //img color filter
		imgFilterWhite:
			'brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(230deg) brightness(107%) contrast(107%);', //img color white filter

		gradientBg: 'linear-gradient(270deg, #0E4C88 0%, #0E4C88 100%)',

		borderColor: '#eaebed',
		themeColor1: '#169191',
		themeColor2: '#202020',
		themeColor3: '#71717A',
		themeColor4: '#E4E4E7',
		themeColor5: '#1a2e40',
		themeColor6: '#A1A1AA',
		themeColor7: '#F6F6F6',
		// fontPoppins: `'Poppins', sans-serif !important;`,
		// fontDM: "'DM Sans', sans-serif !important ",
		fontInter: "'Inter', sans-serif !important ",
	},
};
export const XThemeLayout = styled(Layout)`
	background: none !important;
	margin-bottom: 15px;
`;
export const XContainer = styled(Container)`
	// margin-left: 10px;
	padding: 0px 30px;
	@media only screen and (max-width: 768.99px) {
		padding: 0px 15px;
	}
	@media only screen and (min-width: 1920.99px) {
		width: 1800px;
	}
	@media only screen and (min-width: 2000.99px) {
		width: 100%;
	}
`;
export const XThemeContainer = styled(Container)`
	padding: 0px 30px;
	@media only screen and (max-width: 768.99px) {
		padding: 0px 15px;
	}
	@media only screen and (min-width: 1920.99px) {
		width: 1800px;
	}
	@media only screen and (min-width: 2000.99px) {
		width: 100%;
	}
`;
export const XTheme2Button = styled(Button)`
	background: ${({ theme }) => theme.CQColors.gradientBg} !important;
	border-radius: 16px;
	font-weight: 600;
	font-size: 14px;
	line-height: 30px;
	color: ${({ theme }) => theme.CQColors.white};
	transition: all 0.35s;
	min-height: 36px;
	img,
	svg {
		color: ${({ theme }) => theme.CQColors.white} !important;
		filter: ${({ theme }) => theme.CQColors.imgFilterWhite} !important;
	}
	&:hover {
		transition: all 0.35s;
		background: ${({ theme }) => theme.CQColors.white} !important;
		color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
		border: 1px solid ${({ theme }) => theme.CQColors.secondaryColor} !important;
		img,
		svg {
			color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
			filter: ${({ theme }) => theme.CQColors.imgFilterColor} !important;
		}
	}
	&:disabled {
		background: ${({ theme }) => theme.CQColors.secondaryColor} !important;
		color: ${({ theme }) => theme.CQColors.white} !important;
		border: 1px solid ${({ theme }) => theme.CQColors.secondaryColor} !important;
		opacity: 0.6;
		img,
		svg {
			filter: ${({ theme }) => theme.CQColors.imgFilterWhite} !important;
		}
	}
	&.noBackground,
	&.backgroundRevers {
		position: relative;
		min-height: 36px;
		border-radius: 16px;
		color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
		transition: all 0.35s;
		background: ${({ theme }) => theme.CQColors.white} !important;
		border: 1px solid ${({ theme }) => theme.CQColors.secondaryColor} !important;
		img,
		svg {
			filter: ${({ theme }) => theme.CQColors.imgFilterColor} !important;
		}
		&:hover {
			border: 1px solid ${({ theme }) => theme.CQColors.secondaryColor} !important;
			background: ${({ theme }) => theme.CQColors.gradientBg} !important;
			color: ${({ theme }) => theme.CQColors.white} !important;
			&::before {
				display: none;
			}
			svg,
			img {
				filter: ${({ theme }) =>
					theme.CQColors.imgFilterWhite} !important;
			}
		}
	}
	&.borderColor {
		border: 1px solid ${({ theme }) => theme.CQColors.borderColor} !important;
	}
	&.chatStyle {
		width: 30px !important;
		height: 30px !important;
		min-height: 30px !important;
		border-radius: 5px !important;
		line-height: 30px !important;
		svg {
			font-size: 14px !important;
		}
	}
	&.fixButton {
		position: absolute;
		top: 50%;
		right: 20px;
		transform: translate(0%, -50%);
		z-index: 99;
		width: 30px;
		height: 30px;
		border-radius: 10px;
	}
	&.noBorder {
		border: none !important;
		box-shadow: none !important;
		border-radius: 0px 10px 10px 0px;
	}
`;
export const XTheme2MainTitle = styled.h1`
	width: 100%;
	position: relative;
	margin: 0px;
	font-weight: 600;
	font-size: 20px;
	line-height: 24px;
	color: ${({ theme }) => theme.CQColors.primaryColor} !important;
	span {
		color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
	}
	&.style1 {
		font-weight: 500;
		font-size: 20px;
		line-height: 150%;
		letter-spacing: -0.02em;
		color: ${({ theme }) => theme.CQColors.primaryColor};
		svg {
			color: ${({ theme }) => theme.CQColors.secondaryColor};
			margin-left: 5px;
		}
	}
`;
export const XTheme2MainTitle2 = styled.span`
	margin-right: 10px;
	font-weight: 600;
	font-size: 16px;
	line-height: 24px;
	color: ${({ theme }) => theme.CQColors.themeColor2};
	font-family: ${({ theme }) => theme.CQColors.fontInter};
	display: inline-block;
	span {
		font-weight: 500;
		font-size: 14px;
		line-height: 24px;
		color: ${({ theme }) => theme.CQColors.themeColor3};
	}
`;
export const XTheme2VATag = styled(Tag)`
	background: rgba(255, 255, 255, 0.1) !important;
	border: 1px solid rgba(0, 0, 0, 0.15) !important;
	padding: 10px 20px !important;
	border-radius: 10px !important;
	font-weight: 400 !important;
	font-size: 12px !important;
	line-height: 12px !important;
	color: ${({ theme }) => theme.CQColors.themeColor2} !important;
	opacity: 0.6;
	margin-bottom: 7px;
`;
export const XTheme2Form = styled(Form)``;

export const XTheme2CustomTabsTable = styled(Tabs)`
	background: ${({ theme }) => theme.colors.white};
	border: 1px solid ${({ theme }) => theme.CQColors.borderColor};
	border-radius: 10px;
	.ant-tabs {
		font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
	}
	.ant-tabs-nav::before {
		display: none;
	}
	.ant-tabs-nav {
		background: ${({ theme }) => theme.colors.white};
		border: none;
		border-radius: 10px;
		padding: 10px;
		margin-bottom: 5px;
	}
	/* .ant-tabs-tab:hover .ant-tabs-tab-btn {
		color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
	} */
	.ant-tabs-tab {
		background: ${({ theme }) => theme.CQColors.white} !important;
		border: 1px solid ${({ theme }) => theme.CQColors.borderColor} !important;
		margin: 5px !important;
		border-radius: 12px !important;
		font-weight: 400;
		font-size: 14px;
		line-height: 20px;
		color: ${({ theme }) => theme.CQColors.primaryColor} !important;
		span {
			color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
			font-weight: 500 !important;
		}
		&:hover,
		&:focus,
		&:active,
		&.ant-tabs-tab-active {
			background: ${({ theme }) => theme.CQColors.gradientBg}!important;
			color: ${({ theme }) => theme.CQColors.white} !important;
			.ant-tabs-tab-btn,
			span {
				color: ${({ theme }) => theme.CQColors.white} !important;
			}
		}
	}
	/* Table triangle Status */
	table > thead > tr:first-child > *:first-child {
		border-start-start-radius: 0px !important;
	}
	table > thead > tr:first-child > *:last-child {
		border-start-end-radius: 0px !important;
	}
	.showDate img {
		margin-right: 10px;
		margin-top: -3px;
	}
	td.custom-border-left {
		// border-left: 10px solid green !important;
		// border-radius: 20px !important;
		padding: 0 !important;
	}
	td > .claim_category_line {
		height: 70px !important;
		display: grid;
		place-items: center;
	}
	td > .full {
		border-left: 5px solid #00a954 !important;
	}
	td > .neutral {
		border-left: 5px solid #e9ecef !important;
	}
	td > .rejected {
		border-left: 5px solid #ff1c1c !important;
	}
	td > .partial {
		border-left: 5px solid #ffd17b !important;
	}
	td > .triangle {
		// width: 0;
		// height: 0;
		display: grid;
		place-items: center;
		position: absolute;
		top: 0;
	}
	td > .in_process {
		border-right: 20px solid transparent;
		border-top: 20px solid #1f9254 !important;
	}
	td > .untimely {
		border-right: 20px solid transparent;
		border-top: 20px solid #db3a17 !important;
	}
	td > .escalation {
		border-right: 20px solid transparent;
		border-top: 20px solid #e57711 !important;
	}
	td > .at_risk {
		border-right: 20px solid transparent;
		border-top: 20px solid #e5aa11 !important;
	}
	@media only screen and (max-width: 768px) {
	}
`;
export const XTheme2Table = styled(Table)`
	position: relative;
	background: transparent;
	width: 100%;
	.ant-table {
		background: transparent;
		scrollbar-color: unset !important;
	}
	/* .ant-table-pagination.ant-pagination {
		margin: 15px 0px 0px 0px;
	} */
	.ant-table-cell {
		font-style: normal;
		font-weight: 500 !important;
		font-size: 12px;
		line-height: 16px;
		text-transform: capitalize;
		background: #f9f9f9 !important;
		border-top: none !important;
		border-bottom: none !important;
		color: ${({ theme }) => theme.CQColors.themeColor2} !important;
		font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
		border-radius: 0px !important;
		a {
			font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
			color: ${({ theme }) => theme.CQColors.themeColor2} !important;
			text-decoration: underline;
		}
		&:first-child {
			border-radius: 0px !important;
		}
		&:last-child {
			border-radius: 0px !important;
		}
	}
	td.ant-table-cell {
		text-transform: capitalize;
		font-weight: 400 !important;
		font-size: 12px;
		background: ${({ theme }) => theme.CQColors.white} !important;
		color: ${({ theme }) => theme.CQColors.themeColor2} !important;
		font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
		&:first-child {
			border-radius: 0px !important;
		}
		&:last-child {
			border-radius: 0px !important;
		}
	}
	tr {
		&:last-child {
			td.ant-table-cell {
				&:first-child {
					border-radius: 0px 0px 0px 15px !important;
				}
				&:last-child {
					border-radius: 0px 0px 15px 0px !important;
				}
			}
		}
	}
	.ant-table-fixed-column {
		.ant-table {
			border-radius: 15px 15px 0px 0px !important;
		}
		tr {
			&:last-child {
				td.ant-table-cell {
					&:first-child {
						border-radius: 5px !important;
					}
					&:last-child {
						border-radius: 5px !important;
					}
				}
			}
		}
	}
	ul.ant-pagination {
		margin: 15px !important;
		.ant-pagination-jump-next,
		.ant-pagination-jump-prev {
			border-radius: 5px !important;
		}
		li.ant-pagination-item,
		.ant-pagination-jump-next,
		.ant-pagination-jump-prev,
		.ant-pagination-prev button,
		.ant-pagination-next button {
			/* background: ${({ theme }) => theme.colors.bodyBg}; */
			background: ${({ theme }) => theme.CQColors.bodyBg};
			color: ${({ theme }) => theme.CQColors.primaryColor};
			border-radius: 50%;
			font-weight: 600;
			font-size: 13px;
			.ant-pagination-item-ellipsis {
				font-size: 8px !important;
				color: ${({ theme }) => theme.CQColors.primaryColor} !important;
			}
			&:hover,
			&.ant-pagination-item-active {
				background: ${({ theme }) => theme.CQColors.gradientBg};
				color: ${({ theme }) => theme.CQColors.white} !important;
				border-color: transparent;
				.ant-pagination-item-link-icon {
					color: ${({ theme }) => theme.CQColors.white} !important;
				}
			}
		}
		li.ant-pagination-disabled button {
			background: transparent;
			color: ${({ theme }) => theme.CQColors.borderColor};
			border-radius: 50%;
			font-weight: 600;
			font-size: 13px;
			&:hover {
				background: ${({ theme }) =>
					theme.colors.themeColor22} !important;
				color: ${({ theme }) => theme.CQColors.primaryColor} !important;
				border-color: ${({ theme }) => theme.CQColors.borderColor};
			}
		}
		.ant-select-selector {
			border-color: ${({ theme }) =>
				theme.CQColors.borderColor} !important;
			font-size: 12px !important;
			line-height: 12px !important;
		}
	}
	/* Table triangle Status */
	.showDate img {
		margin-right: 10px;
		margin-top: -3px;
	}
	td.custom-border-left {
		// border-left: 10px solid green !important;
		// border-radius: 20px !important;
		padding: 0 !important;
	}
	td > .claim_category_line {
		height: 70px !important;
		display: grid;
		place-items: center;
	}
	td > .full {
		border-left: 2px solid #00a954 !important;
	}
	td > .neutral {
		border-left: 2px solid #e9ecef !important;
	}
	td > .rejected {
		border-left: 2px solid #ff1c1c !important;
	}
	td > .partial {
		border-left: 2px solid #ffd17b !important;
	}
	td > .triangle {
		display: grid;
		place-items: center;
		position: absolute;
		top: 0;
	}
	td > .in_process {
		border-right: 20px solid transparent;
		border-top: 20px solid #1f9254 !important;
	}
	td > .untimely {
		border-right: 20px solid transparent;
		border-top: 20px solid #db3a17 !important;
	}
	td > .escalation {
		border-right: 20px solid transparent;
		border-top: 20px solid #e57711 !important;
	}
	td > .at_risk {
		border-right: 20px solid transparent;
		border-top: 20px solid #e5aa11 !important;
	}

	// select checkbox in table
	.ant-checkbox-inner {
		border-color: ${({ theme }) => theme.colors.themeColor8} !important;
		background: #e6f3ff !important;
	}
	.ant-checkbox-inner {
		&:after {
			border-color: ${({ theme }) => theme.colors.themeColor8} !important;
		}
	}
	.ant-checkbox-indeterminate {
		.ant-checkbox-inner {
			&:after {
				background: ${({ theme }) =>
					theme.CQColors.themeColor2} !important;
			}
		}
	}
	th.ant-table-selection-column,
	td.ant-table-selection-column {
		padding-left: 20px !important;
	}
	.ant-table-content {
		&::-webkit-scrollbar {
			width: 2px;
			height: 2px;
			background: ${({ theme }) => theme.CQColors.borderColor} !important;
		}
		&::-webkit-scrollbar-thumb {
			background: ${({ theme }) => theme.CQColors.themeColor6} !important;
		}
		&::-webkit-scrollbar {
			width: 3px;
			height: 3px;
			background: ${({ theme }) => theme.CQColors.borderColor} !important;
		}
		&::-webkit-scrollbar-thumb {
			background: ${({ theme }) => theme.CQColors.themeColor6} !important;
		}
	}
`;
export const XTheme2InputText = styled(Input)`
	width: 100%;
	position: relative;
	background: ${({ theme }) => theme.colors.white} !important;
	border: 1px solid ${({ theme }) => theme.colors.themeColor22} !important;
	border-radius: 25px !important;
	font-weight: 400 !important;
	font-size: 13px !important;
	line-height: 22px !important;
	color: ${({ theme }) => theme.colors.themeColor2} !important;
	&.noBorderRadius {
		border-radius: 10px !important;
	}
	&.largeInputForms {
		border-radius: 10px !important;
		line-height: 28px !important;
		font-size: 16px !important;
		border: 1px solid ${({ theme }) => theme.colors.themeColor23} !important;
	}

	&:hover,
	&:focus {
	}
`;
export const XTheme2RadioButton = styled(Radio)`
	margin-top: 10px;
	color: ${({ theme }) => theme.CQColors.primaryColor};
	font-weight: 400;
	font-size: 12px !important;
	line-height: 16px !important;
	.ant-form-item-control-input {
		min-height: auto !important;
	}
	.ant-radio-checked .ant-radio-inner {
		background: ${({ theme }) => theme.CQColors.secondaryColor};
		border-color: ${({ theme }) => theme.CQColors.secondaryColor};
	}
	&.ant-radio-wrapper-checked {
		span {
			color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
		}
	}
	&.largeRadioButton {
		font-size: 14px !important;
		line-height: 14px !important;
	}
`;
export const XTheme2Tag = styled(Tag)`
	border-radius: 4px;
	font-family: ${({ theme }) => theme.colors.fontInter};
	font-size: 12px;
	font-style: normal;
	font-weight: 500;
	letter-spacing: 0.36px;
	padding-left: 20px;
	border: none;
	&:before {
		content: '■';
		position: absolute;
		top: -1px;
		left: 5px;
		font-size: 10px;
	}
`;
export const XTheme2Select = styled(Select)`
	width: 100%;
	.ant-select-selector {
		background: ${({ theme }) => theme.colors.white} !important;
		border: 1px solid ${({ theme }) => theme.colors.themeColor22} !important;
		border-radius: 25px !important;
		font-weight: 400 !important;
		font-size: 13px !important;
		line-height: 16px !important;
		color: ${({ theme }) => theme.colors.themeColor2} !important;
	}
	&.noBorderRadius {
		.ant-select-selector {
			border-radius: 10px !important;
		}
	}
	&.largeInputForms {
		/* &.{
			.ant-select-selector {
				padding-left: 15px !important;
			}
		} */
		.ant-select-selector {
			height: 44px !important;
			border-radius: 10px !important;
			line-height: 44px !important;
			font-size: 16px !important;
			border: 1px solid ${({ theme }) => theme.colors.themeColor23} !important;
			/* padding-left: 30px !important; */
		}
		/* .ant-select-selection-overflow + span.ant-select-selection-placeholder {
			margin-top: -1px;
			height: 44px !important;
			line-height: 44px !important;
			font-size: 16px !important;
			padding-left: 20px !important;
		} */
	}
`;
export const XTheme2TableCircleTag = styled(Tag)`
	border-radius: 10px;
	font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	letter-spacing: 0.36px;
	padding-left: 20px;
	padding-right: 10px;
	border: none;
	&:before {
		content: '\u{25CF}';
		position: absolute;
		top: 0px;
		left: 10px;
		font-size: 10px;
	}
	&.staticTag {
		position: absolute;
		top: 15%;
		left: 30%;
		padding: 8px 10px !important;
		color: ${({ theme }) => theme.CQColors.themeColor2} !important;
		border-radius: 50%;
		background: rgba(224, 230, 236, 0.5) !important;
		box-shadow: inset 0px 15px 15px rgba(255, 255, 255, 0.8) !important;
		border: 1px solid ${({ theme }) => theme.CQColors.borderColor} !important;
		&:before {
			display: none !important;
			content: '' !important;
		}
	}
`;
export const XThemeCustomSteps = styled(Steps)`
	display: inline !important;
	.ant-steps-item-title {
		&::after {
			display: none !important;
		}
	}
	.ant-steps-item-icon {
		background: #f5f5f5 !important;
		font-weight: 500;
		font-size: 14px;
		color: ${({ theme }) => theme.CQColors.themeColor4};
		border-color: ${({ theme }) => theme.CQColors.white};
	}
	.ant-steps-item-title {
		font-weight: 400;
		font-size: 14px;
		color: ${({ theme }) => theme.CQColors.themeColor4};
	}
	.ant-steps-item-active {
		.ant-steps-item-icon {
			background: linear-gradient(
				180deg,
				#82c446 0%,
				#169191 100%
			) !important;
			border-color: ${({ theme }) => theme.CQColors.white};
		}
	}
	.ant-steps-item-active {
		.ant-steps-item-title {
			color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
		}
	}
`;
export const XTheme2AffixCard = styled(Card)`
	background: ${({ theme }) => theme.colors.white};
	border: 1px solid ${({ theme }) => theme.colors.themeColor22};
	border-radius: 10px;
	.ant-card-body {
		border-radius: 10px;
		border: none;
		@media only screen and (max-width: 768.99px) {
			padding: 10px !important;
		}
	}
`;
export const XTheme2QueryCard = styled(Card)`
	.ant-card-body {
		padding: 15px !important;
		background: ${({ theme }) => theme.CQColors.borderColor} !important;
		border-radius: 10px !important;
		border: none !important;
		.title {
			font-size: 14px !important;
			font-weight: 500 !important;
			line-height: 20px !important;
			color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
			margin-bottom: 10px !important;
		}
		.para1 {
			margin: 0 !important;
			font-size: 14px !important;
			font-weight: 400 !important;
			line-height: 20px !important;
		}
	}
`;
export const XTheme2TagsDate = styled(Tag)`
	background: ${({ theme }) => theme.CQColors.bodyBg};
	border: 1px solid ${({ theme }) => theme.CQColors.secondaryColor};
	color: ${({ theme }) => theme.CQColors.secondaryColor};
	padding: 10px 15px !important;
	font-weight: 400;
	font-size: 16px;
	line-height: 22px;
	border-radius: 20px;
	.anticon-close {
		padding: 3px !important;
		font-size: 12px;
		background: ${({ theme }) => theme.CQColors.secondaryColor};
		color: ${({ theme }) => theme.colors.white};
		border-radius: 15px;
		margin-left: 30px;
		&:hover {
			color: ${({ theme }) => theme.colors.white};
		}
	}
	@media only screen and (max-width: 767.99px) {
	}
`;
export const XTheme2ModalCard = styled(Card)`
	margin-top: 15px;
	border: 1px solid ${({ theme }) => theme.CQColors.borderColor};
	border-radius: 10px;
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
	color: ${({ theme }) => theme.CQColors.secondaryColor};
	cursor: pointer;
	&:hover {
		border: 1px solid ${({ theme }) => theme.CQColors.secondaryColor};
	}
	img {
		margin-bottom: 10px;
		filter: ${({ theme }) => theme.CQColors.imgFilterColor};
	}
	&.shareModalActive {
		.ant-card-body {
			padding: 15px !important;
		}
		border: 1px solid ${({ theme }) => theme.CQColors.secondaryColor};
		background: ${({ theme }) => theme.CQColors.secondaryColor};
		color: ${({ theme }) => theme.CQColors.white};
		img,
		svg {
			filter: ${({ theme }) => theme.CQColors.imgFilterWhite} !important;
		}
	}
	@media only screen and (max-width: 767.99px) {
	}
`;
export const GlobalStyle = createGlobalStyle`
	*{
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}
	h1, h2, h3, h4, h5, h6, p, a{
		font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
	}
	body{
        margin:0px;
        padding:0px;
		font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
		background: ${({ theme }) => theme.CQColors.bodyBg} !important;
	}
	.loginBody{
		background: ${({ theme }) => theme.CQColors.white} !important;
	}
	.mainContent{
		padding-top: 90px;
		/* @media only screen and (max-width: 991.99px) {
			padding-top: 90px;
		} */
	}
	.ant-layout-has-sider, .ant-layout{
		background:transparent !important;
	}
	a, p{
		font-family:${({ theme }) => theme.CQColors.fontInter} !important;
		font-weight:normal;
		text-decoration:none;
	}
	.links2{
		color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
		font-weight: 500;
		font-size: 14px;
		line-height: 28px;
	}
	.textArea{
		border-radius: 20px;
		border: 1px solid rgba(0, 0, 0, 0.10);
		background: ${({ theme }) => theme.colors.white} !important;
		box-shadow: 0px 2px 10px 0px rgba(25, 15, 64, 0.05);
		padding:10px 15px !important;
	}
    .logo{
		display:inline;
		text-align: left;
		font-weight: 600;
		font-size: 16px;
		line-height: 22px;
		color: ${({ theme }) => theme.CQColors.themeColor2};

		@media (max-width: 992px) {
			margin:0px;
		}
	}
	.logo img{
		vertical-align: middle;
		border-style: none;
		margin-right: 10px;
	}    
	.ant-menu-item {
		margin: 15px auto !important;
		padding-left: 20px !important; 
	}
	.ant-menu-title-content, 
	.ant-menu-submenu-arrow{
		color: ${({ theme }) => theme.colors.themeColor1} !important;
		font-size: 12px !important;
		font-weight: 500 !important;
		span.newBadge{
			background: linear-gradient(270deg, rgba(22, 145, 145, 0.7) 0%, rgba(130, 196, 70, 0.7) 100%);
			border-radius: 35.7143px;
			color: #fff;
			padding: 4px 7px;
			font-size: 10px;
			margin: 0px 0px 0px 5px;
		}
		span.sidebarTitle{			
			font-weight: 500;
			font-size: 12px;
			line-height: 18px;
			letter-spacing: 1px;
			text-transform: uppercase;
			color: ${({ theme }) => theme.CQColors.themeColor6};
		}
	}
	.ant-menu-item{	
		margin: 5px auto !important;
		&.ant-menu-item-disabled{
			margin: 15px auto 0px auto !important;
		}
		.ant-menu-title-content, a{
			color: ${({ theme }) => theme.colors.themeColor1} !important;
			font-size: 12px !important;
			font-weight: 500 !important;
		}

		&.ant-menu-item-selected, 
		&.ant-menu-item-active{
			&::before{
				content: '';
				position: absolute;
				top: 0px;
				left: 0px;
				width: 5px;
				height: 100%;
				background: #0e4c88 !important;
				// background: linear-gradient(180deg, #82C446 0%, #169191 100%);
				/* rotate: 90deg; */
				border-top-right-radius:10px;
				border-bottom-right-radius:10px;
				border-top-left: 10px solid transparent;
				border-bottom-left:10px solid transparent;
				/* border-top-right: 30px solid transparent; */
			}
			.ant-menu-title-content, a{
				color:  #0e4c88 !important;
			}
			img{
				filter: brightness(0) saturate(100%) invert(15%) sepia(83%) saturate(2722%) hue-rotate(197deg) brightness(94%) contrast(89%);
			}
		}
		img{
			filter: brightness(0) saturate(100%) invert(8%) sepia(10%) saturate(2867%) hue-rotate(182deg) brightness(95%) contrast(96%);
		}
	}

	.ant-menu-submenu-title{
		padding-left: 15px !important;
		
	}
	.ant-menu-submenu-title a{
		color: ${({ theme }) => theme.colors.themeColor1} !important;
		font-size: 12px !important;
		font-weight: 500 !important;
	}

	.sidebarFooter{
		position: relative;
		width: 100%;
		background: transparent;
		border-top: 1px solid ${({ theme }) => theme.colors.themeColor22};
		
	}
	.offcanvas-header{
		border-bottom:1px solid #CCC;
	}
	.offcanvas.offcanvas-top{
		height:100vh;
		transition:transform 0.3s ease-in-out !important;
		z-index:1050;
		@media only screen and (max-width: 1199.99px) {
			padding-top:60px;
		}
	}
    .ant-layout-sider-children, .ant-menu-light {
		background: transparent;
	}	
	.ant-layout-sider-children{
		overflow-y: scroll;
	}
	.ant-layout-sider-children::-webkit-scrollbar {
		width: .2em; 
	}	
	.ant-layout-sider-children::-webkit-scrollbar,
	.ant-layout-sider-children::-webkit-scrollbar-thumb {
		overflow:visible;
		border-radius: 4px;
	}
	.ant-layout-sider-children::-webkit-scrollbar-thumb {
		background: rgba(0,0,0,.2); 
	}	
	.overlayDrawerCloseBtn{
		display:none;
	}
	@media only screen and (max-width: 992px) {
		/********** Mobile overlay menu */  
		display: none;
		.overlayDrawerClose{
			position: fixed;
			display: block;
			width:100%;
			min-height: 100vh;
			top:0;
			right:0%;
			background-color: rgba(0, 0, 0, 0.7);
			animation-direction: normal;
			animation-name: cssAnimation;
			animation-duration:0.15s;
			z-index: 10;
		}
		.overlayDrawerCloseBtn{
			position: absolute;
			top:15px;
			right:20px;
			font-size:3rem !important;
			line-height:2rem;
			background:none !important;
			color: #FFF !important;
			font-weight: 200 !important;
			box-shadow:0px;
			padding:0px;
			display:block;
			border:none;
		}
        #root  .ant-layout-sider-collapsed + .overlayDrawerClose{
            display: block;
        }
        #root .ant-layout-sider-zero-width + .overlayDrawerClose{
            display: none;
        }
        .ant-layout-header{
            background:  ${({ theme }) => theme.colors.white};
        }
		
	}
	/* Mobile navigation menu  */
	.centerMenuSpace{
		.nav-link {
			font-size: 14px !important;
			margin: 2px 0px !important;
			color: ${({ theme }) => theme.CQColors.themeColor2} !important;
			&.active {
				color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
			}
		}
		.sidebarTitle {
			margin-top: 10px !important;
			font-weight: 500;
			font-size: 12px;
			line-height: 18px;
			letter-spacing: 1px;
			text-transform: uppercase;
			color: ${({ theme }) => theme.CQColors.themeColor6} !important;
		}
	}
	.caseManagementSubMenu{
		.dropdown-menu{
			border:none !important;
			border-radius: 0px !important;
			padding: 0px 15px !important;
			margin-bottom: 5px !important;
			a{
				display: block !important;
				font-size: 14px !important;
				font-weight: 400 !important;
				padding-bottom: 10px !important;
				color: ${({ theme }) => theme.CQColors.themeColor2} !important;
			}
		}
		
	}
	button.xThemeButtonSubmit{
		background: ${({ theme }) => theme.CQColors.gradientBg} !important;
		border-color: #FFF !important;
		border-radius: 5px !important;
		font-weight: 500 !important;
		font-size: 14px !important;
		line-height: 21px !important;
		text-align: center !important;
		color: ${({ theme }) => theme.CQColors.white} !important;
		padding: 0px 20px !important;
		box-shadow: none !important;
		&:hover{
			background: ${({ theme }) => theme.CQColors.white} !important;
			border-color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
			color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
		}
	}
	button.xThemeCancelSubmit{
		background: ${({ theme }) => theme.CQColors.white} !important;
		border: 1px solid ${({ theme }) => theme.CQColors.secondaryColor} !important;
		border-radius: 5px !important;
		font-weight: 500 !important;
		font-size: 14px !important;
		line-height: 21px !important;
		text-align: center !important;
		color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
		padding: 0px 20px !important;
		box-shadow: none !important;
		&:hover{
			background: ${({ theme }) => theme.CQColors.gradientBg}	!important;
			border: 1px solid ${({ theme }) => theme.CQColors.secondaryColor} !important;
			color: ${({ theme }) => theme.CQColors.white} !important;
		}
	}
	
	.ant-modal-confirm {
		/* .ant-btn{
			&:hover{
				border-color: ${({ theme }) => theme.colors.menu2} !important;
			}
		} */
		.ant-btn-dangerous{
			background: ${({ theme }) => theme.CQColors.gradientBg} !important;
			color: ${({ theme }) => theme.CQColors.white} !important;
			border-color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
			&:hover{
				background: ${({ theme }) => theme.CQColors.white} !important;
				color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
				border-color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
			}
		}
		/* .ant-btn-default{
			background: ${({ theme }) => theme.colors.white};
			color: ${({ theme }) => theme.colors.menu2};
			border-color: ${({ theme }) => theme.colors.color3};
			&:hover{
				background: ${({ theme }) => theme.colors.menu2} !important;
				color: ${({ theme }) => theme.colors.white} !important;
			}
		} */
	}
/******************** End new theme ****************/	
	.marginTopMobile {
		@media only screen and (max-width: 991.99px) {
			margin-bottom: 100px;
		}
	}

	.marginTopMobileNoHeader {
		@media only screen and (max-width: 991.99px) {
			margin-top: -90px !important;
		}
	}
	.marginBottomMobile {
		@media only screen and (max-width: 991.99px) {
			margin-bottom: 70px !important;
		}
	}
	.marginNone {
		@media only screen and (max-width: 991.99px) {
			margin-top: -70px !important;
		}
	}
	.nav-link {
		color: ${({ theme }) => theme.colors.menu1};
		font-size: 16px;
		font-style: normal;
		font-weight: 400;
		line-height: 24px;
		&:hover {
			color: ${({ theme }) => theme.colors.menu2} !important;
			font-weight: 600;
		}
	}
	.nav-link.active {
		color: ${({ theme }) => theme.colors.menu2} !important;
		font-size: 16px;
		font-style: normal;
		font-weight: 600;
		line-height: 24px;
	}
	
	.ant-select.ant-select-in-form-item,
	.ant-input,
	.ant-picker,
	.ant-select-selector,
	.ant-input-affix-wrapper {
		background: transparent !important;
	}
	

	.textArea{
		border-radius: 20px;
		border: 1px solid rgba(0, 0, 0, 0.10);
		background: ${({ theme }) => theme.colors.white} !important;
		box-shadow: 0px 2px 10px 0px rgba(25, 15, 64, 0.05);
		padding:10px 15px !important;
	}
	.iconResp{
		width:35px;
		@media only screen and (max-width: 769px) {
			width:36px;
		}
	}
	p.modalPara1{
		color: rgba(33, 34, 38, 0.60);
		font-family: ${({ theme }) => theme.colors.fontInter};
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
		line-height: 22px;
	}
	.confirmModal {
		.ant-btn{
			border-radius: 5px !important;	
		}
		.ant-btn-default{
			background: ${({ theme }) => theme.colors.white};
			border: 1px solid ${({ theme }) => theme.colors.menu2};
			color: ${({ theme }) => theme.colors.menu2};
		};
		.ant-btn-dangerous{
			background: ${({ theme }) => theme.colors.menu2};
			color: ${({ theme }) => theme.colors.white};
		};

	}
	.slideBox {
		overflow: hidden;
		@media only screen and (min-width: 2000.99px) {
			margin-top:5%;
		}
		@media (max-width: 768.99px) {
			padding-top:7%;
		}
		@media (max-width: 992.99px) {
			padding-top:3%;
		}
		@media (max-width: 1024.99px) {
			padding-top:3%;
		}
	}
	.slideUp {
		
		position: relative;
		transition: all .5s ease-out;
	}
	.slideDown {
		position: relative;
		transition: all .5s ease-out;
		height: 100%;
	}
	.top-0{
		top:0;
	}
	.bottom-0{
		position: relative;
		bottom:0 !important;
	}
	.top-100{
		top:100%!important;
	}
	.bottom-100{
		position: absolute;
		bottom:100% !important;
		z-index: -1;
	}
	.ant-layout-sider-children{
		overflow-y: scroll;
	}
	.ant-layout-sider-children::-webkit-scrollbar {
		width: .2em; 
	}	
	.ant-layout-sider-children::-webkit-scrollbar,
	.ant-layout-sider-children::-webkit-scrollbar-thumb {
		overflow:visible;
		border-radius: 4px;
	}
	.ant-layout-sider-children::-webkit-scrollbar-thumb {
		background: rgba(0,0,0,.2); 
	}
	.cover-bar {
		position: absolute;
		background: ${({ theme }) => theme.colors.bodyBg};
		height: 100%;  
		top: 0;
		right: 0;
		width: .2em;
		-webkit-transition: all .5s;
		opacity: 1;
	}
	.customScroll:hover .cover-bar {
		opacity: 0;
		-webkit-transition: all .5s;
	}
	
	
	${
		'' /* .customScroll::-webkit-scrollbar {
		width: 2px !important;
	}
	.customScroll:hover {
		overflow-y:auto !important;
	}
	.customScroll::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 0px rgba(0, 0, 0, 0);
		border-radius: 10px;
		background-color: ${Theme.colors.color3} !important;
	}
	.customScroll::-webkit-scrollbar-thumb {
		height: 5px;
		background-color: ${Theme.colors.color4};
		border-radius:5px;
	}
	.customScroll::-webkit-scrollbar-thumb:hover {
		background-color: ${Theme.colors.color2};
	} */
	}

	.customHorizontalScroll ::-webkit-scrollbar {
		height: 5px !important;
	}
	.customHorizontalScroll ::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 0px rgba(0, 0, 0, 0);
		border-radius: 10px;
		background-color: ${Theme.colors.color3} !important;
	}
	.customHorizontalScroll ::-webkit-scrollbar-thumb {
		width: 5px;
		background-color: ${Theme.colors.color4};
		border-radius:5px;
	}
	.customHorizontalScroll ::-webkit-scrollbar-thumb:hover {
		background-color: ${Theme.colors.color2};
	}

	.headerStyle {
		color: #000;
		font-size: 18px;
		font-style: normal;
		font-weight: 600;
		line-height: 20px;
		letter-spacing: -0.36px;
	}
	.labelStyle{
		color: #171C26;
		font-family: Poppins;
		font-size: 14px;
		font-style: normal;
		font-weight: 600;
		padding-bottom: 0 !important;
	}
	.labelStyle .ant-form-item-label{
		padding:0px !important;
	}

	
	.subLabelStyle{
		color: #171C26;
		font-family: Poppins;
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
	}

	.feedbackText{
		color: #000;
		font-family: Poppins;
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
		line-height: 26px; /* 185.714% */
		letter-spacing: -0.28px;
		
	}

	.feedbackCardHeader{
		margin-left: 8px;
		color: #212226;
		font-family: Poppins;
		font-size: 16px;
		font-style: normal;
		font-weight: 500;
		line-height: 16px; /* 100% */
		letter-spacing: -0.32px;
	}
	.feedbackTextArea{
		border-radius: 20px;
		border: 1px solid rgba(0, 0, 0, 0.10);
		background: #FFF;
		box-shadow: 0px 2px 10px 0px rgba(25, 15, 64, 0.05);
		color: rgba(0, 0, 0, 0.40);
		font-family: Inter;
		font-size: 18px;
		font-style: normal;
		font-weight: 400;
		line-height: 30px; /* 166.667% */
		letter-spacing: -0.36px;
		height:200px;
		padding:20px !important;
	}

	:where(.css-dev-only-do-not-override-3mqfnx).ant-input-affix-wrapper:focus, :where(.css-dev-only-do-not-override-3mqfnx).ant-input-affix-wrapper:focus-within{
		border: 0.1px grey !important;
		box-shadow: 0.5px 0.5px 2px 0.2px #888888;
	}

	:where(.css-dev-only-do-not-override-3mqfnx).ant-input-affix-wrapper:focus, :where(.css-dev-only-do-not-override-3mqfnx).ant-input-affix-wrapper:hover{
		border: 0.1px grey !important;
		box-shadow: 0.5px 0.5px 2px 0.2px #888888;
	}
	.ant-form-item-control-input-content .ant-switch-checked{
		background: ${({ theme }) => theme.colors.menu2};
		.ant-switch-handle {
			top: 1px;
			&::before {
				background: ${({ theme }) => theme.colors.white};
			}
		}
	}
	
	:where(.css-dev-only-do-not-override-3mqfnx).ant-switch.ant-switch-checked:hover:not(.ant-switch-disabled){
		background: ${({ theme }) => theme.colors.menu2};
		.ant-switch-handle {
			top: 1px;
			&::before {
				background: ${({ theme }) => theme.colors.white};
			}
		}
	}
	
	.remove_important > .ant-form-item-required{
		color:green !important;
	}
	canvas{
		width:10%;
	}
	
	.shareModal .ant-card-body{
		padding:15px !important;
	}
	
	.tableHeader{
		color: #11263C;
		font-family: Poppins;
		font-size: 14px;
		font-style: normal;
		font-weight: 600;
		line-height: 1.2; /* 114.286% */
	}
	
	.filter-sub-item{
		color: #11263C !important;
		font-family: Poppins;
		font-size: 12px !important;
		font-style: normal !important;
		font-weight: 500 !important;
		line-height: 18px !important; /* 150% */
		letter-spacing: 0.36px !important;
		margin: 5px auto;
	}
	.removeFormMargin{
		margin-bottom: 14px !important;
	}
	.ant-drawer-body{
		padding-top: 14px !important;
	}
	.ant-upload-select {
		width: 100% !important;
	}


	.confirmCoverage:hover {
		box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
		background: ${({ theme }) => theme.colors.themeColor1} !important;
	}

	ul.listCircule{
        margin: 0px;
        padding: 0px;
    }
    ul.listCircule li{
        list-style-type: disc;
		font-family: ${({ theme }) => theme.CQColors.fontInter};
		color: ${({ theme }) => theme.colors.themeColor1};
		font-size: 15px;
		font-weight: 400;
		line-height: 28px !important;
		margin-bottom: 5px !important;
    } 
    ${
		'' /* ul.listCircule li::before {
        content: "";
        border:2px solid #5E5E5E;
        border-radius: 50%;
        font-weight: bold;
        display: inline-block; 
        width: 0.7em;
        height:0.7em;
        margin-right:.5em;
        } */
	}
	.dashboard-img {
		height: 240px !important;
	}
	.config-text {
		color: #212226;
		font-family: Inter;
		font-size: 18px;
		font-style: normal;
		font-weight: 600 !important;
		line-height: 28px; /* 155.556% */
	}
	.criteria_list {
		border-left: 5px solid #9B68BF;
		padding-left: 25px;
		height: 50px;
		width: 375px;
		display: flex;
		align-items: center;
		background:
			linear-gradient(90deg, rgba(207, 174, 223, 0.15) 0.1%, rgba(207, 174, 223, 0.00) 99.86%);
		@media only screen and (max-width: 768.99px) {
			padding: 15px !important;
		}
	}

	.criteria_sub_list {
		padding-left: 25px !important;
		@media only screen and (max-width: 768.99px) {
			padding:0px 15px !important;
		}
	}

	.criteria_list_title {
		color: #9B68BF;
	}

	.supporting_files .ant-upload-select {
		width: 102px !important;
		margin:0 !important;
	}

	.supporting_files .ant-upload-list-item-container {
		margin-right:12px !important;
		margin-bottom: 0 !important;
	}

	.ant-upload-list-item-container {
		margin-right: 19px !important;
	}

	:where(.css-dev-only-do-not-override-3mqfnx).ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
		color: #212226 !important;
	}

	.no-padding-card .ant-card-body{
		padding:0 !important;
	}

	#revnueModalUploadButton:hover{
		color: black !important;
	}
	.timeline-documents .ant-card-body{
		padding:15px;
	}
	#timeline-documents-hover .ant-card-body{
		padding:5px !important;
		display: flex;
		justify-content: center;
		height: 100%;
		background: none;
		box-shadow: none;
	}
	.timeline-upload .ant-upload-list{
		display: flex;
		flex-wrap: wrap;
		row-gap: 10px;
	}

	//Flip Card Timeline
	.front,.back{
		backface-visibility: hidden;
		transition: transform .6s linear;
	}
	.front {
		transform: perspective(600px) rotateY(0deg);
	}
	.back{
		 transform: perspective(600px) rotateY(-180deg); 
	}
	.toggle.rotated > .front{
		transform: perspective(600px) rotateY(180deg);
	}
	.toggle.rotated > .back{ 
		transform: perspective(600px) rotateY(0deg);
	}

	.supporting-docs-hover, .ant-image-mask{
		border-radius: 10px !important;
	}

	.image-container, .image-container_case_filing {
		position: relative;
	  }
	.imgBoxButton{
		background: #ffffff;
		border: 1px solid #d1d7e5;
		box-shadow: inset 0px -5px 2px #eeeff7 !important;
		border-radius: 10px;
		padding-bottom:5px;
	}
	  .image-container, .uploadText {
		position: relative;
		text-align:center;
		font-size: 12px;
		line-height:28px;
		color: rgb(0, 0, 0);
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		width: 75px;
	  }
	  .image-container {
		width: 100px;
		height: 100px;
	  }
	  
	  .supporting-docs-hover, .overlay, .overlay_case_filing {
		border-radius: 10px;
	  }
	  
	  .overlay, .overlay_case_filing {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.5); /* Mask the image */
		display: flex;
		align-items: center;
		justify-content: center;
		opacity: 0;
		transition: opacity 0.3s ease;
	  }
	  
	  .image-container:hover .overlay, .image-container_case_filing:hover .overlay_case_filing {
		opacity: 1;
	  }
	  
	  .icon {
		color: white;
		font-size: 24px;
		margin: 0 5px;
		cursor: pointer;
	  }
	  
	.dashboard-picker.ant-picker{
		background: #FFFFFF !important;
		width: 240px !important;
		border-radius: 25px !important;
		margin: 0 5px !important;
		border: 1px solid rgba(6, 36, 66, 0.1) !important;
		color: #212226 !important;
	}
	.dashboard-picker.ant-picker-input{
		color: #212226 !important;
	}
		.dashboard-picker .ant-picker-input > input {
		font-size: 14px !important; /* Adjust this size as needed */
	}
	#tooltip-card .ant-card-body{
		padding:5px !important;
		display: flex;
		justify-content: center;
		height: 100%;
		background: none;
		box-shadow: none;
	}
	ul.markData {
		margin: 0px;
		padding: 0px;
	}
	ul.markData li {
		display: list-item;
		list-style-type: none;
		padding-left: 10px;
		font-weight: 500;
		font-size: 14px;
		line-height: 32px;
		letter-spacing: -0.02em;
		color: #FFFF;
		text-align: left;
	}
	ul.markData li em {
		position: absolute;
		left: 0;
		margin-top: 10px;
		width: 10px;
		height: 10px;
		border-radius: 20px;
	}
	#tooltip-card ul.markData li em.color1 {
		background: #1f9254;
	}
	#tooltip-card ul.markData li em.color2 {
		background: #e5aa11;
	}
	#tooltip-card ul.markData li em.color3 {
		background: #e53711;
	}
	#tooltip-card ul.markData li em.color4 {
		background: #2F8DFA;
	}
	#tooltip-card ul.markData li em.color5 {
		background: #1FD0BF;
	}
	#tooltip-card ul.markData li em.color6 {
		background: #D5001A;
	}
	#tooltip-card.ant-tooltip-inner{
		padding:5px 20px
	}
	
	.case-filing:hover {
		cursor:pointer !important;
	}
	.normal-header .ant-list-header {
		font-size: 10px !important;
		padding: 10px !important;
		font-family: 'Inter', sans-serif !important;
		background: none !important;
	}
	// .custom-crop-modal .ant-modal-body .reactEasyCrop_CropArea {
	// 	width: 40px !important;
	// 	height: 40px !important;
	// }

	// .custom-crop-modal .ant-modal-body .reactEasyCrop_CropArea {
	// 	width: 40px !important;
	// 	height: 40px !important;
	// 	aspect-ratio: 1 / 1;
	// }

	.rpv-core__inner-pages{
		scrollbar-width:none !important;
	}
	.rpv-core__page-layer--single{
		margin:0 !important;
		width:100% !important;
	}
	:where(.css-dev-only-do-not-override-98ntnt).ant-select-outlined.ant-select-disabled:not(.ant-select-customize-input) .ant-select-selector {
		background: rgba(0, 0, 0, 0.04) !important;
	}
	:where(.css-dev-only-do-not-override-98ntnt).ant-picker-outlined.ant-picker-disabled {
		background: rgba(0, 0, 0, 0.04) !important;
	}
	:where(.css-dev-only-do-not-override-98ntnt).ant-input-outlined.ant-input-disabled, :where(.css-dev-only-do-not-override-98ntnt).ant-input-outlined[disabled] {
		background: rgba(0, 0, 0, 0.04) !important;
	}
	@media only screen and (max-width: 992.99px) {
        #getQust{
            width:100% !important; 
        }
    }
	/************ Added new styles ***************/
	.shieldMaxxBG{
		background: ${({ theme }) =>
			theme.CQColors
				.bodyBg} url('../images/shield-maxx-bg.svg') no-repeat -150px
		center !important;
		
	}

	// added modal title icon
	span.modalTitleIcon{
		margin-right: 10px;
		background: ${({ theme }) => theme.CQColors.secondaryColor};
		border-radius: 50%;
		padding: 5px;
		display: inline-block;
		min-width: 36px;
		min-height: 36px;
		line-height: 24px;
		text-align: center;
		outline: 3px solid rgba(14, 76, 136, 0.1);
		box-shadow: 
			0 0 0 3px rgba(14, 76, 136, 0.2),
			0 0 0 6px rgba(14, 76, 136, 0.1);
	}
`;

//End new theme Global style
